var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvoidTollsMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43,14H12V5c0-1.6542969-1.3457031-3-3-3H3C1.3457031,2,0,3.3457031,0,5v41h1h1V30h8v16h1h1V24h31 c2.7568359,0,5-2.2431641,5-5S45.7568359,14,43,14z M43,22h-5.2791138l2-6H43c1.6542969,0,3,1.3457031,3,3S44.6542969,22,43,22z  M10,28H2V10h8v4H9c-2.7568359,0-5,2.2431641-5,5s2.2431641,5,5,5h1V28z M3,4h6c0.5512695,0,1,0.4482422,1,1v3H2V5 C2,4.4482422,2.4487305,4,3,4z M21.6124878,16l-2,6h-5.8916016l2-6H21.6124878z M29.6124878,16l-2,6h-5.8916016l2-6H29.6124878z  M37.6124878,16l-2,6h-5.8916016l2-6H37.6124878z M11.6124878,22H9c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3h4.6124878 L11.6124878,22z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvoidTollsMedium);
export default __webpack_public_path__ + "static/media/avoid-tolls--medium.00a2029655cf2d5ec9a2764f4b1402eb.svg";
export { ForwardRef as ReactComponent };